import { AvailableLanguage } from 'helpers/language';

export enum OrganizationType {
    Admin = 'admin',
    Retailer = 'retailer',
    Manufacturer = 'manufacturer'
}

export enum Plan {
    Basic = 'basic',
    Premium = 'premium'
}

export interface Organization {
    _id: string;
    name: string;
    type: OrganizationType;
    phone: string;
    plan: Plan;
    isTest?: boolean;
    brands: { _id: string; name: string }[];
    apiKeys: { internal: string; ecommerce?: string };
    packages: {
        reorder?: boolean;
        stock?: boolean;
        api?: boolean;
        ecommerce?: boolean;
        excalibur?: boolean;
        requestMarketingFiles?: boolean;
        unrestrictedDownloads?: boolean;
    };
    address: {
        line1: string;
        line2?: string;
        zip: string;
        city: string;
        country: string;
    };
    shops?: { _id: string }[];
}

export type Auth0Organization = {
    /**
     * This is the FC Organization ID, mapped from the Auth0 `name` field.
     *
     * @type {string}
     */
    _id: string;

    /**
     * This is the FC Organization name, mapped from the Auth0 `display_name` field.
     *
     * @type {string}
     */
    name: string;

    /**
     * This is the Auth0 Organization id, mapped from the Auth0 `id` field.
     *
     * @type {string}
     */
    id: string;

    /**
     * Custom metadata attached to the Auth0 Organization.
     */
    metadata: {
        /**
         * The type of the FC Organization.
         */
        org_type?: OrganizationType;
    };
};

export interface User {
    _id: string;
    type: OrganizationType;
    plan: Plan;
    privileges: string[];
    preferredLanguage: AvailableLanguage;
    accessToken: string;
    refreshToken: string;
    created: string;
    email: string;
    firstname: string;
    surname: string;
    organization: Organization;
    restrictedAccess?: string[];
    assignedOrganizations?: Auth0Organization[];
}
